export default "__VITE_ASSET__DyTe86z6__"